<ng-container [formGroup]="controlGroup" class="hup-subscription-address">
  <div class="row">
  @if (showActivateCheckbox) {
    <div class="col-12 hup-subscription-address__activate-checkbox">
      <mat-checkbox formControlName="showAddress" class="hup-subscription-address__checkbox" (change)="resetFields($event)">
        <div [innerHTML]="translationService.getTranslation(activateCheckboxText)"
             class="hup-subscription-address__checkbox-label"></div>
      </mat-checkbox>
    </div>
  }
  @if (showValidFrom) {
    <mat-form-field class="col-12 hup-subscription-address__valid-from" (click)="picker.open()"
                    formGroupName="validDate">
      <mat-label [innerHTML]="translationService.getTranslation('startdate')"
                 class="hup-subscription-address__label"></mat-label>
      <input matInput [min]="minDate" [matDatepicker]="picker" readonly required formControlName="validFrom"
             class="hup-subscription-address__input">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker [touchUi]="isMobile" #picker></mat-datepicker>
      @if (controlGroup.get('validDate').hasError('message')) {
        <mat-error class="hup-subscription-address__error"
        >{{ controlGroup.get('validDate').getError('message') }}
        </mat-error>
      }
    </mat-form-field>
  }
  @if (!showActivateCheckbox || controlGroup.get('showAddress')?.value) {
    @if (addressType) {
      <h3 class="col-12 fw-bold">{{addressType}}</h3>
    }
    @if (defaultCountry === 'NL') {
      <ng-container formGroupName="person" class="hup-subscription-address__person">
        @if (showSalutation) {
          <mat-form-field class="col-12 col-md-4 hup-subscription-address__salutation">
            <mat-label [innerHTML]="translationService.getTranslation('address_salutation')"
                       class="hup-subscription-address__label"></mat-label>
            <mat-select formControlName="salutation" [required]="isRequired(AddressFormularField.SALUTATION)"
                        [compareWith]="compareBaseData" class="hup-subscription-address__select">
              @for (salutation of salutations; track salutation) {
                @if (salutation.useInFE) {
                  <mat-option [value]="salutation"
                              class="hup-subscription-address__option">{{ salutation.description }}
                  </mat-option>
                }
              }
            </mat-select>
            @if (controlGroup.get('person.salutation').hasError('message')) {
              <mat-error
                class="hup-subscription-address__error">{{ controlGroup.get('person.salutation').getError('message') }}
              </mat-error>
            }
          </mat-form-field>
        }
        <mat-form-field class="col-12 col-md-4 hup-subscription-address__initials">
          <mat-label
            class="hup-subscription-address__label">{{ translationService.getTranslation('address_initials') }}
          </mat-label>
          <input maxLength="50"
                 id="initialInputForm"
                 matInput
                 formControlName="initials"
                 mask="S.S.S.S.S"
                 type="text"
                 [dropSpecialCharacters]="false"
                 [validation]="false" #addressInitials
                 class="hup-subscription-address__input">
          @if (addressInitials === document?.activeElement && addressInitials.value.length >= 1) {
            <mat-hint align="end" class="hup-subscription-address__hint">{{ addressInitials.value.length }}
              / {{ addressInitials.maxLength }}
            </mat-hint>
          }
          @if (controlGroup.get('person.initials').hasError('message')) {
            <mat-error
              class="hup-subscription-address__error">{{ controlGroup.get('person.initials').getError('message') }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="col-12 col-md-4 hup-subscription-address__middlename">
          <mat-label [innerHTML]="translationService.getTranslation('address_surName')"
                     class="hup-subscription-address__label"></mat-label>
          <input maxLength="50" matInput formControlName="middlename" #middleName
                 class="hup-subscription-address__input">
          @if (middleName === document?.activeElement && middleName.value.length >= 1) {
            <mat-hint align="end" class="hup-subscription-address__hint">{{ middleName.value.length }}
              / {{ middleName.maxLength }}
            </mat-hint>
          }
          @if (controlGroup.get('person.middlename').hasError('message')) {
            <mat-error
              class="hup-subscription-address__error">{{ controlGroup.get('person.middlename').getError('message') }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="col-12 col-md-8 hup-subscription-address__lastname">
          <mat-label [innerHTML]="translationService.getTranslation('address_lastname')"
                     class="hup-subscription-address__label"></mat-label>
          <input maxLength="50" matInput formControlName="lastName"
                 [required]="isRequired(AddressFormularField.LAST_NAME)" #lastName
                 class="hup-subscription-address__input">
          @if (lastName === document?.activeElement && lastName.value.length >= 1) {
            <mat-hint align="end" class="hup-subscription-address__hint">{{ lastName.value.length }}
              / {{ lastName.maxLength }}
            </mat-hint>
          }
          @if (controlGroup.get('person.lastName').hasError('message')) {
            <mat-error
              class="hup-subscription-address__error">{{ controlGroup.get('person.lastName').getError('message') }}
            </mat-error>
          }
        </mat-form-field>
      </ng-container>
      <ng-container formGroupName="address" class="hup-subscription-address__address">
        @if (askForCountry) {
          <mat-form-field class="col-12 col-md-4 hup-subscription-address__country">
            <mat-label [innerHTML]="translationService.getTranslation('address_country')"
                       class="hup-subscription-address__label"></mat-label>
            <mat-select formControlName="country" [required]="isRequired(AddressFormularField.COUNTRY)" id="nlCountry"
                        class="hup-subscription-address__select">
              @for (country of countries; track country) {
                <mat-option [value]="country" class="hup-subscription-address__option">{{ country.description }}
                </mat-option>
              }
            </mat-select>
            @if (controlGroup.get('address.country').hasError('message')) {
              <mat-error
                class="hup-subscription-address__error">{{ controlGroup.get('address.country').getError('message') }}
              </mat-error>
            }
          </mat-form-field>
        }
        <mat-form-field class="col-12 col-md-6 hup-subscription-address__zipcode">
          <mat-label [innerHTML]="translationService.getTranslation('address_postcode')"
                     class="hup-subscription-address__label"></mat-label>
          <input matInput formControlName="zipcode" (keyup)="replaceInvalidCharactersFromZipcode()"
                 [required]="isRequired(AddressFormularField.ZIPCODE)" class="hup-subscription-address__input">
          @if (controlGroup.get('address.zipcode').hasError('message')) {
            <mat-error
              class="hup-subscription-address__error">{{ controlGroup.get('address.zipcode').getError('message') }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="col-12 col-md-6 hup-subscription-address__houseno">
          <mat-label [innerHTML]="translationService.getTranslation('address_houseno')"
                     class="hup-subscription-address__label"></mat-label>
          <input maxLength="50" matInput formControlName="houseNo"
                 [required]="isRequired(AddressFormularField.HOUSE_NUMBER)" #houseNumber
                 class="hup-subscription-address__input">
          @if (houseNumber === document?.activeElement && houseNumber.value.length >= 1) {
            <mat-hint align="end" class="hup-subscription-address__hint">{{ houseNumber.value.length }}
              / {{ houseNumber.maxLength }}
            </mat-hint>
          }
          @if (controlGroup.get('address.houseNo').hasError('message')) {
            <mat-error
              class="hup-subscription-address__error">{{ controlGroup.get('address.houseNo').getError('message') }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="col-12 hup-subscription-address__street">
          <mat-label [innerHTML]="translationService.getTranslation('address_street')"
                     class="hup-subscription-address__label"></mat-label>
          <input matInput formControlName="street" [required]="isRequired(AddressFormularField.STREET)"
                 [matAutocomplete]="matStreetNames" class="hup-subscription-address__input">
          <mat-autocomplete #matStreetNames="matAutocomplete">
            @for (street of streetNames; track street) {
              <mat-option [value]="street" class="hup-subscription-address__option">
                {{ street }}
              </mat-option>
            }
          </mat-autocomplete>
          @if (controlGroup.get('address.street').hasError('message')) {
            <mat-error
              class="hup-subscription-address__error">{{ controlGroup.get('address.street').getError('message') }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="col-12 hup-subscription-address__city">
          <mat-label [innerHTML]="translationService.getTranslation('address_city')"
                     class="hup-subscription-address__label"></mat-label>
          <input matInput formControlName="city" [required]="isRequired(AddressFormularField.CITY)"
                 [matAutocomplete]="matCities" class="hup-subscription-address__input">
          <mat-autocomplete #matCities="matAutocomplete">
            @for (city of cities; track city) {
              <mat-option [value]="city" class="hup-subscription-address__option">
                {{ city }}
              </mat-option>
            }
          </mat-autocomplete>
          @if (controlGroup.get('address.city').hasError('message')) {
            <mat-error
              class="hup-subscription-address__error">{{ controlGroup.get('address.city').getError('message') }}
            </mat-error>
          }
        </mat-form-field>
        @if (showAddressExt1) {
          <mat-form-field class="col-12 hup-subscription-address__extraline">
            <mat-label [innerHTML]="translationService.getTranslation('address_extraline1')"
                       class="hup-subscription-address__label"></mat-label>
            <input maxLength="50" matInput formControlName="extraLine" #addressExtra
                   class="hup-subscription-address__input">
            @if (addressExtra === document?.activeElement && addressExtra.value.length >= 1) {
              <mat-hint align="end" class="hup-subscription-address__hint">{{ addressExtra.value.length }}
                / {{ addressExtra.maxLength }}
              </mat-hint>
            }
            @if (controlGroup.get('address.extraLine').hasError('message')) {
              <mat-error
                class="hup-subscription-address__error">{{ controlGroup.get('address.extraLine').getError('message') }}
              </mat-error>
            }
          </mat-form-field>
        }
      </ng-container>
    } @else {
      @if (askForPerson) {
        <ng-container formGroupName="person" class="hup-subscription-address__person">
          @if (showSalutation) {
            <mat-form-field class="col-12 col-md-6 hup-subscription-address__salutation">
              <mat-label [innerHTML]="translationService.getTranslation('address_salutation')"
                         class="hup-subscription-address__label"></mat-label>
              <mat-select formControlName="salutation" [required]="isRequired(AddressFormularField.SALUTATION)"
                          [compareWith]="compareBaseData" data-cy="select-salutation"
                          class="hup-subscription-address__select">
                @for (salutation of salutations; track salutation) {
                  @if (salutation.useInFE) {
                    <mat-option [value]="salutation" data-cy="option-salutation"
                                class="hup-subscription-address__option">{{ salutation.description }}
                    </mat-option>
                  }
                }
              </mat-select>
              @if (controlGroup.get('person.salutation').hasError('message')) {
                <mat-error
                  class="hup-subscription-address__error">{{ controlGroup.get('person.salutation').getError('message') }}
                </mat-error>
              }
            </mat-form-field>
          }
          @if (showTitle) {
            <mat-form-field class="col-12 col-md-6 hup-subscription-address__title">
              <mat-label [innerHTML]="translationService.getTranslation('address_title')"
                         class="hup-subscription-address__label"></mat-label>
              <mat-select formControlName="title" [compareWith]="compareBaseData"
                          class="hup-subscription-address__select">
                <mat-option value="" class="hup-subscription-address__option"></mat-option>
                @for (title of titles; track title) {
                  @if (title.useInFE) {
                    <mat-option [value]="title" class="hup-subscription-address__option">{{ title.description }}
                    </mat-option>
                  }
                }
              </mat-select>
              @if (controlGroup.get('person.title').hasError('message')) {
                <mat-error
                  class="hup-subscription-address__error">{{ controlGroup.get('person.title').getError('message') }}
                </mat-error>
              }
            </mat-form-field>
          }
          @if (identification && customerType == CustomerType.PRIVATE || !identification) {
            <mat-form-field class="col-12 col-md-6 hup-subscription-address__firstname">
              <mat-label [innerHTML]="translationService.getTranslation('address_firstname')"
                         class="hup-subscription-address__label"></mat-label>
              <input maxLength="50" matInput formControlName="firstName"
                     [required]="isRequired(AddressFormularField.FIRST_NAME)"
                     #firstName data-cy="input-first-name" class="hup-subscription-address__input">
              @if (firstName === document?.activeElement && firstName.value.length >= 1) {
                <mat-hint align="end" class="hup-subscription-address__hint">{{ firstName.value.length }}
                  / {{ firstName.maxLength }}
                </mat-hint>
              }
              @if (controlGroup.get('person.firstName').hasError('message')) {
                <mat-error
                  class="hup-subscription-address__error">{{ controlGroup.get('person.firstName').getError('message') }}
                </mat-error>
              }
            </mat-form-field>
          }
          <mat-form-field
            [ngClass]="(identification && customerType == CustomerType.COMPANY) ? 'col-12 hup-subscription-address__companyname' : 'col-12 col-md-6 hup-subscription-address__lastname'">
            <mat-label
              [innerHTML]="identification && customerType == CustomerType.COMPANY ? translationService.getTranslation('address_company_name') : translationService.getTranslation('address_lastname')"
              class="hup-subscription-address__label"></mat-label>
            <input maxLength="50" matInput formControlName="lastName"
                   [required]="isRequired(AddressFormularField.LAST_NAME)" #lastName data-cy="input-last-name"
                   class="hup-subscription-address__input">
            @if (lastName === document?.activeElement && lastName.value.length >= 1) {
              <mat-hint align="end" class="hup-subscription-address__hint">{{ lastName.value.length }}
                / {{ lastName.maxLength }}
              </mat-hint>
            }
            @if (controlGroup.get('person.lastName').hasError('message')) {
              <mat-error
                class="hup-subscription-address__error">{{ controlGroup.get('person.lastName').getError('message') }}
              </mat-error>
            }
          </mat-form-field>
        </ng-container>
      }
      <ng-container formGroupName="address" class="hup-subscription-address__address">
        @if (addressPartSequence == "0") {
            <app-hup-subscription-address-specifics [controlGroup]="controlGroup" [streetNames]="streetNames"
              (searchAddressEmit)="this.searchStreet()" [addressFieldHandler]="addressFieldHandler"
              class="hup-subscription-address__specifics">
            </app-hup-subscription-address-specifics>
            <mat-form-field class="col-12 col-md-6 hup-subscription-address__zipcode">
              <mat-label [innerHTML]="translationService.getTranslation('address_postcode')"
                         class="hup-subscription-address__label"></mat-label>
              <input matInput formControlName="zipcode" (keyup)="replaceInvalidCharactersFromZipcode()"
                     [required]="isRequired(AddressFormularField.ZIPCODE)"
                     [matAutocomplete]="matZipCodes" (focusin)="this.searchZipCode()"
                     class="hup-subscription-address__input">
              <mat-autocomplete #matZipCodes="matAutocomplete">
                @for (zipcode of zipcodes; track zipcode) {
                  <mat-option [value]="zipcode" class="hup-subscription-address__option">
                    {{ zipcode }}
                  </mat-option>
                }
              </mat-autocomplete>

              @if (controlGroup.get('address.zipcode').hasError('message')) {
                <mat-error
                  class="hup-subscription-address__error">{{ controlGroup.get('address.zipcode').getError('message') }}
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field class="col-12 col-md-6 hup-subscription-address__city">
              <mat-label [innerHTML]="translationService.getTranslation('address_city')"
                         class="hup-subscription-address__label"></mat-label>
              <input matInput formControlName="city" [required]="isRequired(AddressFormularField.CITY)"
                     [matAutocomplete]="matCities" (focusin)="this.searchCity()"
                     class="hup-subscription-address__input">
              <mat-autocomplete #matCities="matAutocomplete">
                @for (city of cities; track city) {
                  <mat-option [value]="city" class="hup-subscription-address__option">
                    {{ city }}
                  </mat-option>
                }
              </mat-autocomplete>
              @if (controlGroup.get('address.city').hasError('message')) {
                <mat-error
                  class="hup-subscription-address__error">{{ controlGroup.get('address.city').getError('message') }}
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field class="col-12 hup-subscription-address__country">
              <mat-label [innerHTML]="translationService.getTranslation('address_country')"
                         class="hup-subscription-address__label"></mat-label>
              <mat-select formControlName="country" [required]="isRequired(AddressFormularField.COUNTRY)"
                          [compareWith]="compareBaseData" id="country" class="hup-subscription-address__select">
                @for (country of countries; track country) {
                  <mat-option [value]="country" class="hup-subscription-address__option">{{ country.description }}
                  </mat-option>
                }
              </mat-select>
              @if (controlGroup.get('address.country').hasError('message')) {
                <mat-error
                  class="hup-subscription-address__error">{{ controlGroup.get('address.country').getError('message') }}
                </mat-error>
              }
            </mat-form-field>
        } @else {
          <ng-container #addressPartSequence0>
            <mat-form-field class="col-12 hup-subscription-address__country">
              <mat-label [innerHTML]="translationService.getTranslation('address_country')"
                         class="hup-subscription-address__label"></mat-label>
              <mat-select formControlName="country" [required]="isRequired(AddressFormularField.COUNTRY)"
                          [compareWith]="compareBaseData" id="country0" class="hup-subscription-address__select">
                @for (country of countries; track country) {
                  <mat-option [value]="country" class="hup-subscription-address__option">
                    {{ country.description }}
                  </mat-option>
                }
              </mat-select>
              @if (controlGroup.get('address.country').hasError('message')) {
                <mat-error
                  class="hup-subscription-address__error">{{ controlGroup.get('address.country').getError('message') }}
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field class="col-12 col-md-6 hup-subscription-address__zipcode">
              <mat-label [innerHTML]="translationService.getTranslation('address_postcode')"
                         class="hup-subscription-address__label"></mat-label>
              <input matInput formControlName="zipcode" (keyup)="replaceInvalidCharactersFromZipcode()"
                     [required]="isRequired(AddressFormularField.ZIPCODE)"
                     [matAutocomplete]="matZipCodes" (focusin)="this.searchZipCode()"
                     class="hup-subscription-address__input">
              <mat-autocomplete #matZipCodes="matAutocomplete">
                @for (zipcode of zipcodes; track zipcode) {
                  <mat-option [value]="zipcode" class="hup-subscription-address__option">
                    {{ zipcode }}
                  </mat-option>
                }
              </mat-autocomplete>
              @if (controlGroup.get('address.zipcode').hasError('message')) {
                <mat-error
                  class="hup-subscription-address__error">{{ controlGroup.get('address.zipcode').getError('message') }}
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field class="col-12 col-md-6 hup-subscription-address__city">
              <mat-label [innerHTML]="translationService.getTranslation('address_city')"
                         class="hup-subscription-address__label"></mat-label>
              <input matInput formControlName="city" [required]="isRequired(AddressFormularField.CITY)"
                     [matAutocomplete]="matCities" (focusin)="this.searchCity()"
                     class="hup-subscription-address__input">
              <mat-autocomplete #matCities="matAutocomplete">
                @for (city of cities; track city) {
                  <mat-option [value]="city" class="hup-subscription-address__option">
                    {{ city }}
                  </mat-option>
                }
              </mat-autocomplete>
              @if (controlGroup.get('address.city').hasError('message')) {
                <mat-error
                  class="hup-subscription-address__error">{{ controlGroup.get('address.city').getError('message') }}
                </mat-error>
              }
            </mat-form-field>
            <app-hup-subscription-address-specifics [controlGroup]="controlGroup" [streetNames]="streetNames"
                                                    (searchAddressEmit)="this.searchStreet()"
                                                    [addressFieldHandler]="addressFieldHandler"
                                                    class="hup-subscription-address__specifics">
            </app-hup-subscription-address-specifics>
          </ng-container>
        }

        @if (showAddressExt1) {
          <mat-form-field class="col-12 hup-subscription-address__extraline">
            <mat-label [innerHTML]="translationService.getTranslation('address_extraline1')"
                       class="hup-subscription-address__label"></mat-label>
            <input maxlength="50" matInput formControlName="extraLine" #addressExtra
                   class="hup-subscription-address__input">
            @if (addressExtra === document?.activeElement && addressExtra.value.length >= 1) {
              <mat-hint align="end" class="hup-subscription-address__hint">{{ addressExtra.value.length }}
                / {{ addressExtra.maxLength }}
              </mat-hint>
            }
            @if (controlGroup.get('address.extraLine').hasError('message')) {
              <mat-error
                class="hup-subscription-address__error">{{ controlGroup.get('address.extraLine').getError('message') }}
              </mat-error>
            }
          </mat-form-field>

        }
      </ng-container>
    }
  }
  @if ((!showActivateCheckbox || controlGroup.get('showAddress')?.value) && (askForBirthday || askForEmail || askForPhone)) {
    <ng-container formGroupName="userData" class="hup-subscription-address__userdata">
      @if (askForBirthday) {
        <mat-form-field class="col-12 hup-subscription-address__birthday">
          <mat-label [innerHTML]="translationService.getTranslation('address_birthday')"
                     class="hup-subscription-address__label"></mat-label>
          <input matInput [max]="earliestBirthdateForSubscription"
                 [matDatepicker]="birthDaypicker" formControlName="birthDay"
                 [datePickerFormat]="translationService.getTranslation('dateFormat')"
                 [required]="isRequired(AddressFormularField.BIRTHDAY)"
                 class="hup-subscription-address__input">
          <mat-datepicker-toggle matSuffix [for]="birthDaypicker"></mat-datepicker-toggle>
          <mat-datepicker [touchUi]="isMobile" #birthDaypicker startView="multi-year"></mat-datepicker>
          @if (controlGroup.get('userData').hasError('message')) {
            <mat-error class="hup-subscription-address__error"
            >{{ controlGroup.get('userData').getError('message') }}
            </mat-error>
          }

          @if (controlGroup.get('userData.birthDay').hasError('matDatepickerMax')) {
            <mat-error class="hup-subscription-address__error"
                       [innerHTML]="translationService.getTranslation('subscription.error.minimal-user-age').replace('%s', minimalAllowedUserAge.toString())">
            </mat-error>
          }
        </mat-form-field>
      }
      @if (askForPhone) {
        <mat-form-field class="col-12 hup-subscription-address__phone">
          <mat-label [innerHTML]="translationService.getTranslation('address_telephone')"
                     class="hup-subscription-address__label"></mat-label>
          <input matInput type="tel" formControlName="phone" [required]="isRequired(AddressFormularField.PHONE)"
                 class="hup-subscription-address__input">
          @if (!!controlGroup.get('userData.phone').value && controlGroup.get('userData.phone').valid && !controlGroup.get('userData.phone').pending) {
            <mat-icon matSuffix class="hup-subscription-address__icon">check</mat-icon>
          }
          @if (controlGroup.get('userData.phone').hasError('message')) {
            <mat-error class="hup-subscription-address__error"
            >{{ controlGroup.get('userData.phone').getError('message') }}
            </mat-error>
          }
        </mat-form-field>
      }
      @if (askForEmail) {
        <mat-form-field class="col-12 d-none hup-subscription-address__email">
          <mat-label [innerHTML]="translationService.getTranslation('register_email')"
                     class="hup-subscription-address__label"></mat-label>
          <input matInput formControlName="email" readonly [required]="isRequired(AddressFormularField.EMAIL)"
                 class="hup-subscription-address__input">
          @if (controlGroup.get('userData').hasError('message')) {
            <mat-error class="hup-subscription-address__error"
            >{{ controlGroup.get('userData').getError('message') }}
            </mat-error>
          }
        </mat-form-field>
      }
    </ng-container>
  }
  </div>
</ng-container>
<!--button (click)="printForm()">Print Form</button-->
